"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnuityCheckBox = AnnuityCheckBox;
exports.BondsCheckBox = BondsCheckBox;
exports.BuildWealthMaxInvestmentsCheckBox = BuildWealthMaxInvestmentsCheckBox;
exports.DisabilityIncomeInsuranceCheckBox = DisabilityIncomeInsuranceCheckBox;
exports.ETFsCheckBox = ETFsCheckBox;
exports.EducationSavingsAccountCheckBox = EducationSavingsAccountCheckBox;
exports.EmailInput = void 0;
exports.EnsureFamilyFinanciallySecureGoalCheckBox = EnsureFamilyFinanciallySecureGoalCheckBox;
exports.EstatePlanningServicesCheckBox = EstatePlanningServicesCheckBox;
exports.FirstNameInput = void 0;
exports.HealthSavingsAccountCheckBox = HealthSavingsAccountCheckBox;
exports.IRACheckBox = IRACheckBox;
exports.LTCProtectionCheckBox = LTCProtectionCheckBox;
exports.LastNameInput = void 0;
exports.LifeInsuranceCheckBox = LifeInsuranceCheckBox;
exports.MoneyMarketCDCheckBox = MoneyMarketCDCheckBox;
exports.MutualFundsCheckBox = MutualFundsCheckBox;
exports.OtherInvestmentsCheckBox = OtherInvestmentsCheckBox;
exports.PensionCheckBox = PensionCheckBox;
exports.PhoneInput = void 0;
exports.PlanningRetirementGoalCheckBox = PlanningRetirementGoalCheckBox;
exports.Retirement401kCheckBox = Retirement401kCheckBox;
exports.Retirement403bCheckBox = Retirement403bCheckBox;
exports.Retirement457CheckBox = Retirement457CheckBox;
exports.SaveForEducationalExpensesGoalCheckBox = SaveForEducationalExpensesGoalCheckBox;
exports.SaveForMajorPurchaseGoalCheckBox = SaveForMajorPurchaseGoalCheckBox;
exports.SavingsAccountCheckBox = SavingsAccountCheckBox;
exports.StocksCheckBox = StocksCheckBox;
exports.TaxPlanningCheckBox = TaxPlanningCheckBox;
exports.TransitionWealthGoalCheckBox = TransitionWealthGoalCheckBox;
exports.TrustServicesCheckBox = TrustServicesCheckBox;
exports.ZipInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _FinancialPlanningCheckupWizardTool = require("./FinancialPlanningCheckupWizardTool.config");
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// PAGE 1 Components
function PlanningRetirementGoalCheckBox(props) {
  var {
    setFieldValue,
    isPlanningRetirementGoal,
    goalsList
  } = props;
  var fieldName = 'planningRetirementGoalCheckBox';
  var name = 'planningForRetirementGoalCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'PlanningForRetirementGoalCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: /*#__PURE__*/_asyncToGenerator(function* () {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'isPlanningRetirementGoal');
      setFieldValue('isPlanningRetirementGoal', !isPlanningRetirementGoal);
      if (!isPlanningRetirementGoal) {
        goalsList.push(_FinancialPlanningCheckupWizardTool.goalsValues.isPlanningRetirementGoal);
      } else {
        goalsList.splice(goalsList.indexOf(_FinancialPlanningCheckupWizardTool.goalsValues.isPlanningRetirementGoal), 1);
      }
    })
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isPlanningRetirementGoal,
    defaultChecked: isPlanningRetirementGoal
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label"
  }, _FinancialPlanningCheckupWizardTool.goalsValues.isPlanningRetirementGoal)))));
}
function TransitionWealthGoalCheckBox(props) {
  var {
    setFieldValue,
    isTransitioningWealthGoal,
    goalsList
  } = props;
  var fieldName = 'transitionWealthGoalCheckBox';
  var name = 'transitionWealthGoalCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'TransitionWealthGoalCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'transitionWealthGoalCheckBox');
      setFieldValue('isTransitioningWealthGoal', !isTransitioningWealthGoal);
      if (!isTransitioningWealthGoal) {
        goalsList.push(_FinancialPlanningCheckupWizardTool.goalsValues.isTransitioningWealthGoal);
      } else {
        goalsList.splice(goalsList.indexOf(_FinancialPlanningCheckupWizardTool.goalsValues.isTransitioningWealthGoal), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isTransitioningWealthGoal,
    defaultChecked: isTransitioningWealthGoal
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label"
  }, _FinancialPlanningCheckupWizardTool.goalsValues.isTransitioningWealthGoal)))));
}
function SaveForMajorPurchaseGoalCheckBox(props) {
  var {
    setFieldValue,
    isSavingForMajorPurchaseGoal,
    goalsList
  } = props;
  var fieldName = 'savingForMajorPurchaseGoalCheckBox';
  var name = 'savingForMajorPurchaseGoalCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'SavingForMajorPurchaseGoalCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'savingForMajorPurchaseGoalCheckBox');
      setFieldValue('isSavingForMajorPurchaseGoal', !isSavingForMajorPurchaseGoal);
      if (!isSavingForMajorPurchaseGoal) {
        goalsList.push(_FinancialPlanningCheckupWizardTool.goalsValues.isSavingForMajorPurchaseGoal);
      } else {
        goalsList.splice(goalsList.indexOf(_FinancialPlanningCheckupWizardTool.goalsValues.isSavingForMajorPurchaseGoal), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isSavingForMajorPurchaseGoal,
    defaultChecked: isSavingForMajorPurchaseGoal
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label"
  }, _FinancialPlanningCheckupWizardTool.goalsValues.isSavingForMajorPurchaseGoal)))));
}
function BuildWealthMaxInvestmentsCheckBox(props) {
  var {
    setFieldValue,
    isBuildWealthGoal,
    goalsList
  } = props;
  var fieldName = 'buildingWealthCheckBox';
  var name = 'buildingWealthCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'BuildingWealthCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'buildingWealthCheckBox');
      setFieldValue('isBuildWealthGoal', !isBuildWealthGoal);
      if (!isBuildWealthGoal) {
        goalsList.push(_FinancialPlanningCheckupWizardTool.goalsValues.isBuildWealthGoal);
      } else {
        goalsList.splice(goalsList.indexOf(_FinancialPlanningCheckupWizardTool.goalsValues.isBuildWealthGoal), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isBuildWealthGoal,
    defaultChecked: isBuildWealthGoal
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label"
  }, _FinancialPlanningCheckupWizardTool.goalsValues.isBuildWealthGoal)))));
}
function SaveForEducationalExpensesGoalCheckBox(props) {
  var {
    setFieldValue,
    isSavingForEducationExpensesGoal,
    goalsList
  } = props;
  var fieldName = 'savingForEducationalExpensesGoalCheckBox';
  var name = 'savingForEducationalExpensesGoalCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'SavingForEducationalExpensesGoalCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'savingForEducationalExpensesGoalCheckBox');
      setFieldValue('isSavingForEducationExpensesGoal', !isSavingForEducationExpensesGoal);
      if (!isSavingForEducationExpensesGoal) {
        goalsList.push(_FinancialPlanningCheckupWizardTool.goalsValues.isSavingForEducationExpensesGoal);
      } else {
        goalsList.splice(goalsList.indexOf(_FinancialPlanningCheckupWizardTool.goalsValues.isSavingForEducationExpensesGoal), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isSavingForEducationExpensesGoal,
    defaultChecked: isSavingForEducationExpensesGoal
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label"
  }, _FinancialPlanningCheckupWizardTool.goalsValues.isSavingForEducationExpensesGoal)))));
}
function EnsureFamilyFinanciallySecureGoalCheckBox(props) {
  var {
    setFieldValue,
    isFamilyFinanciallySecureGoal,
    goalsList
  } = props;
  var fieldName = 'ensurefamilyfinanciallysecureGoalCheckBox';
  var name = 'ensurefamilyfinanciallysecureGoalCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'EnsurefamilyfinanciallysecureGoalCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'ensurefamilyfinanciallysecureGoalCheckBox');
      setFieldValue('isFamilyFinanciallySecureGoal', !isFamilyFinanciallySecureGoal);
      if (!isFamilyFinanciallySecureGoal) {
        goalsList.push(_FinancialPlanningCheckupWizardTool.goalsValues.isFamilyFinanciallySecureGoal);
      } else {
        goalsList.splice(goalsList.indexOf(_FinancialPlanningCheckupWizardTool.goalsValues.isFamilyFinanciallySecureGoal), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isFamilyFinanciallySecureGoal
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label"
  }, _FinancialPlanningCheckupWizardTool.goalsValues.isFamilyFinanciallySecureGoal)))));
}

// PAGE 2 Components
function EstatePlanningServicesCheckBox(props) {
  var {
    setFieldValue,
    hasEstatePlanningServices,
    productsOwnedList
  } = props;
  var fieldName = 'estatePlanningServicesCheckBox';
  var name = 'estatePlanningServicesCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'EstatePlanningServicesCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'EstatePlanningServicesCheckBox');
      setFieldValue('hasEstatePlanningServices', !hasEstatePlanningServices);
      if (!hasEstatePlanningServices) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasEstatePlanningServices);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasEstatePlanningServices), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasEstatePlanningServices,
    defaultChecked: hasEstatePlanningServices
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "planningRetirementGoalCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasEstatePlanningServices)))));
}
function TrustServicesCheckBox(props) {
  var {
    setFieldValue,
    hasTrustServices,
    productsOwnedList
  } = props;
  var fieldName = 'trustServicesCheckBox';
  var name = 'trustServicesCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'TrustServicesCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'TrustServicesCheckBox');
      setFieldValue('hasTrustServices', !hasTrustServices);
      if (!hasTrustServices) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasTrustServices);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasTrustServices), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasTrustServices,
    defaultChecked: hasTrustServices
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "planningRetirementGoalCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasTrustServices)))));
}
function TaxPlanningCheckBox(props) {
  var {
    setFieldValue,
    hasTaxPlanning,
    productsOwnedList
  } = props;
  var fieldName = 'taxPlanningCheckBox';
  var name = 'taxPlanningCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'TaxPlanningCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'TaxPlanningCheckBox');
      setFieldValue('hasTaxPlanning', !hasTaxPlanning);
      if (!hasTaxPlanning) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasTaxPlanning);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasTaxPlanning), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasTaxPlanning,
    defaultChecked: hasTaxPlanning
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "taxPlanningCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasTaxPlanning)))));
}
function SavingsAccountCheckBox(props) {
  var {
    setFieldValue,
    hasSavingsAccount,
    productsOwnedList
  } = props;
  var fieldName = 'savingsAccountCheckBox';
  var name = 'savingsAccountCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'SavingsAccountCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'SavingsAccountCheckBox');
      setFieldValue('hasSavingsAccount', !hasSavingsAccount);
      if (!hasSavingsAccount) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasSavingsAccount);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasSavingsAccount), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasSavingsAccount,
    defaultChecked: hasSavingsAccount
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "savingsAccountCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasSavingsAccount)))));
}
function HealthSavingsAccountCheckBox(props) {
  var {
    setFieldValue,
    hasHealthSavingsAccount,
    productsOwnedList
  } = props;
  var fieldName = 'healthSavingsAccountCheckBox';
  var name = 'healthSavingsAccountCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'HealthSavingsAccountCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'HealthSavingsAccountCheckBox');
      setFieldValue('hasHealthSavingsAccount', !hasHealthSavingsAccount);
      if (!hasHealthSavingsAccount) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasHealthSavingsAccount);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasHealthSavingsAccount), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasHealthSavingsAccount,
    defaultChecked: hasHealthSavingsAccount
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "healthSavingsAccountCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasHealthSavingsAccount)))));
}
function EducationSavingsAccountCheckBox(props) {
  var {
    setFieldValue,
    hasEducationSavingsAccount,
    productsOwnedList
  } = props;
  var fieldName = 'educationSavingsAccountCheckBox';
  var name = 'educationSavingsAccountCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'EducationSavingsAccountCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'EducationSavingsAccountCheckBox');
      setFieldValue('hasEducationSavingsAccount', !hasEducationSavingsAccount);
      if (!hasEducationSavingsAccount) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasEducationSavingsAccount);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasEducationSavingsAccount), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasEducationSavingsAccount,
    defaultChecked: hasEducationSavingsAccount
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "educationSavingsAccountCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasEducationSavingsAccount)))));
}
function LifeInsuranceCheckBox(props) {
  var {
    setFieldValue,
    hasLifeInsurance,
    productsOwnedList
  } = props;
  var fieldName = 'lifeInsuranceCheckBox';
  var name = 'lifeInsuranceCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'LifeInsuranceCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'LifeInsuranceCheckBox');
      setFieldValue('hasLifeInsurance', !hasLifeInsurance);
      if (!hasLifeInsurance) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasLifeInsurance);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasLifeInsurance), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasLifeInsurance,
    defaultChecked: hasLifeInsurance
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "lifeInsuranceCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasLifeInsurance)))));
}
function LTCProtectionCheckBox(props) {
  var {
    setFieldValue,
    hasLTCProtection,
    productsOwnedList
  } = props;
  var fieldName = 'ltcProtectionCheckBox';
  var name = 'ltcProtectionCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'LTCProtectionCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'LTCProtectionCheckBox');
      setFieldValue('hasLTCProtection', !hasLTCProtection);
      if (!hasLTCProtection) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasLTCProtection);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasLTCProtection), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasLTCProtection,
    defaultChecked: hasLTCProtection
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "ltcProtectionCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasLTCProtection)))));
}
function DisabilityIncomeInsuranceCheckBox(props) {
  var {
    setFieldValue,
    hasDisabilityIncomeInsurance,
    productsOwnedList
  } = props;
  var fieldName = 'disabilityIncomeInsuranceCheckBox';
  var name = 'disabilityIncomeInsuranceCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'DisabilityIncomeInsuranceCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'DisabilityIncomeInsuranceCheckBox');
      setFieldValue('hasDisabilityIncomeInsurance', !hasDisabilityIncomeInsurance);
      if (!hasDisabilityIncomeInsurance) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasDisabilityIncomeInsurance);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasDisabilityIncomeInsurance), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasDisabilityIncomeInsurance,
    defaultChecked: hasDisabilityIncomeInsurance
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "disabilityIncomeInsuranceCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasDisabilityIncomeInsurance)))));
}
function Retirement401kCheckBox(props) {
  var {
    setFieldValue,
    has401k,
    productsOwnedList
  } = props;
  var fieldName = 'retirement401kCheckBox';
  var name = 'retirement401kCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'Retirement401kCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'Retirement401kCheckBox');
      setFieldValue('has401k', !has401k);
      if (!has401k) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.has401k);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.has401k), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: has401k,
    defaultChecked: has401k
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "retirement401kCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.has401k)))));
}
function Retirement403bCheckBox(props) {
  var {
    setFieldValue,
    has403b,
    productsOwnedList
  } = props;
  var fieldName = 'retirement403bCheckBox';
  var name = 'retirement403bCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'Retirement403bCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'Retirement403bCheckBox');
      setFieldValue('has403b', !has403b);
      if (!has403b) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.has403b);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.has403b), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: has403b,
    defaultChecked: has403b
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "retirement403bCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.has403b)))));
}
function Retirement457CheckBox(props) {
  var {
    setFieldValue,
    has457,
    productsOwnedList
  } = props;
  var fieldName = 'retirement457CheckBox';
  var name = 'retirement457CheckBox';
  var type = 'checkbox';
  var ariaLabel = 'Retirement457CheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'Retirement457CheckBox');
      setFieldValue('has457', !has457);
      if (!has457) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.has457);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.has457), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: has457,
    defaultChecked: has457
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "retirement457CheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.has457)))));
}
function IRACheckBox(props) {
  var {
    setFieldValue,
    hasIRA,
    productsOwnedList
  } = props;
  var fieldName = 'iraCheckBox';
  var name = 'iraCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'IRACheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'IRACheckBox');
      setFieldValue('hasIRA', !hasIRA);
      if (!hasIRA) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasIRA);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasIRA), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasIRA,
    defaultChecked: hasIRA
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "iraCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasIRA)))));
}
function PensionCheckBox(props) {
  var {
    setFieldValue,
    hasPension,
    productsOwnedList
  } = props;
  var fieldName = 'pensionCheckBox';
  var name = 'pensionCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'PensionCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'PensionCheckBox');
      setFieldValue('hasPension', !hasPension);
      if (!hasPension) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasPension);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasPension), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasPension,
    defaultChecked: hasPension
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "pensionCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasPension)))));
}
function AnnuityCheckBox(props) {
  var {
    setFieldValue,
    hasAnnuity,
    productsOwnedList
  } = props;
  var fieldName = 'annuityCheckBox';
  var name = 'annuityCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'AnnuityCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'AnnuityCheckBox');
      setFieldValue('hasAnnuity', !hasAnnuity);
      if (!hasAnnuity) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasAnnuity);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasAnnuity), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasAnnuity,
    defaultChecked: hasAnnuity
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "annuityCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasAnnuity)))));
}
function MoneyMarketCDCheckBox(props) {
  var {
    setFieldValue,
    hasMoneyMarketCD,
    productsOwnedList
  } = props;
  var fieldName = 'moneyMarketCDCheckBox';
  var name = 'moneyMarketCDCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'MoneyMarketCDCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'MoneyMarketCDCheckBox');
      setFieldValue('hasMoneyMarketCD', !hasMoneyMarketCD);
      if (!hasMoneyMarketCD) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasMoneyMarketCD);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasMoneyMarketCD), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasMoneyMarketCD,
    defaultChecked: hasMoneyMarketCD
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "moneyMarketCDCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasMoneyMarketCD)))));
}
function StocksCheckBox(props) {
  var {
    setFieldValue,
    hasStocks,
    productsOwnedList
  } = props;
  var fieldName = 'stocksCheckBox';
  var name = 'stocksCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'StocksCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'StocksCheckBox');
      setFieldValue('hasStocks', !hasStocks);
      if (!hasStocks) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasStocks);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasStocks), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasStocks,
    defaultChecked: hasStocks
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "stocksCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasStocks)))));
}
function BondsCheckBox(props) {
  var {
    setFieldValue,
    hasBonds,
    productsOwnedList
  } = props;
  var fieldName = 'bondsCheckBox';
  var name = 'bondsCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'BondsCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'BondsCheckBox');
      setFieldValue('hasBonds', !hasBonds);
      if (!hasBonds) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasBonds);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasBonds), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasBonds,
    defaultChecked: hasBonds
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "bondsCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasBonds)))));
}
function MutualFundsCheckBox(props) {
  var {
    setFieldValue,
    hasMutualFunds,
    productsOwnedList
  } = props;
  var fieldName = 'mutualFundsCheckBox';
  var name = 'mutualFundsCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'MutualFundsCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'MutualFundsCheckBox');
      setFieldValue('hasMutualFunds', !hasMutualFunds);
      if (!hasMutualFunds) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasMutualFunds);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasMutualFunds), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasMutualFunds,
    defaultChecked: hasMutualFunds
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "mutualFundsCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasMutualFunds)))));
}
function ETFsCheckBox(props) {
  var {
    setFieldValue,
    hasETFs,
    productsOwnedList
  } = props;
  var fieldName = 'etfsCheckBox';
  var name = 'etfsCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'ETFsCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'ETFsCheckBox');
      setFieldValue('hasETFs', !hasETFs);
      if (!hasETFs) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasETFs);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasETFs), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasETFs,
    defaultChecked: hasETFs
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "etfsCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasETFs)))));
}
function OtherInvestmentsCheckBox(props) {
  var {
    setFieldValue,
    hasOtherInvestments,
    productsOwnedList
  } = props;
  var fieldName = 'otherInvestmentsCheckBox';
  var name = 'otherInvestmentsCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'OtherInvestmentsCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'OtherInvestmentsCheckBox');
      setFieldValue('hasOtherInvestments', !hasOtherInvestments);
      if (!hasOtherInvestments) {
        productsOwnedList.push(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasOtherInvestments);
      } else {
        productsOwnedList.splice(productsOwnedList.indexOf(_FinancialPlanningCheckupWizardTool.productsOwnedValues.hasOtherInvestments), 1);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: hasOtherInvestments,
    defaultChecked: hasOtherInvestments
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label label",
    htmlFor: "otherInvestmentsCheckBox"
  }, _FinancialPlanningCheckupWizardTool.productsOwnedValues.hasOtherInvestments)))));
}

// PAGE 4 Components
var FirstNameInput = _ref2 => {
  var {
    errors,
    touched,
    values
  } = _ref2;
  var fieldName = 'firstName';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    label: "First name*",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "text",
    maxLength: "40",
    minLength: "2",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
};
exports.FirstNameInput = FirstNameInput;
var LastNameInput = _ref3 => {
  var {
    errors,
    touched,
    values
  } = _ref3;
  var fieldName = 'lastName';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    label: "Last name*",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "text",
    maxLength: "80",
    minLength: "2",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
};
exports.LastNameInput = LastNameInput;
var PhoneInput = _ref4 => {
  var {
    errors,
    touched,
    values
  } = _ref4;
  var fieldName = 'phone';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().phoneNumberFormatter({
      usaFormat: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    label: "Phone number*",
    errors: errors,
    touched: touched,
    values: values,
    type: "tel",
    inputMode: "tel",
    maxLength: "15",
    minLength: "10",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    placeholder: '(XXX) XXX-XXXX'
  });
};
exports.PhoneInput = PhoneInput;
var EmailInput = _ref5 => {
  var {
    errors,
    touched,
    values
  } = _ref5;
  var fieldName = 'email';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    label: "Email address*",
    errors: errors,
    touched: touched,
    values: values,
    type: "email",
    inputMode: "email",
    maxLength: "80",
    minLength: "5",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    placeholder: 'Email'
  });
};
exports.EmailInput = EmailInput;
var ZipInput = _ref6 => {
  var {
    errors,
    touched,
    values
  } = _ref6;
  var fieldName = 'zip';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    label: "ZIP code*",
    errors: errors,
    touched: touched,
    values: values,
    type: "tel",
    inputMode: "tel",
    maxLength: "5",
    minLength: "5",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    placeholder: 'XXXXX'
  });
};
exports.ZipInput = ZipInput;